module.exports = {
   baseurl: "https://mail.coldsender.com",
    // baseurl: "http://192.168.1.17:3000", 
};
